export const Units = ["METRIC", "IMPERIAL"] as const
export type HUUnit = (typeof Units)[number]
export const DEFAULT_UNIT: HUUnit = "METRIC"
